import component from "./TeamTrialResults";

export default component;
